export default __webpack_public_path__ + "static/media/Asia_08.87c6a25e.png";